import * as React from "react";
import Divider from "@mui/material/Divider";
import NavBar from "../../NavBar";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteVehcile } from "../../redux/vehicle/action";
import { getVehicleType } from "../../utils";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useResponsive } from "../../hooks/useResponsive";
import { useRef } from "react";
import MenuBar from "../menuBar";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";
import Carousel from "react-material-ui-carousel";
import { useTranslation } from "react-i18next";

const VehicleDetails = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const lgUp = useResponsive("up", "lg");
  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { selectedVehicle } = useSelector(
    (state) => state.setSelectedVehicleReducer,
  );

  const vdLayout =
    selectedVehicle?.veh_type_cd === "Truck"
      ? {
          veh_type_cd: t("pages.vehicleDetails.text02"),
          dotNumber: t("pages.vehicleDetails.text05"),
          make: t("pages.vehicleDetails.text06"),
          model: t("pages.vehicleDetails.text07"),
          color: t("pages.vehicleDetails.text08"),
          lic_plate_num: t("pages.vehicleDetails.text04"),
        }
      : selectedVehicle?.veh_type_cd === "Trailer" ||
          selectedVehicle?.veh_type_cd === "TRALR"
        ? {
            veh_type_cd: t("pages.vehicleDetails.text02"),
            trailerNumber: t("pages.vehicleDetails.text03"),
            lic_plate_num: t("pages.vehicleDetails.text04"),
          }
        : {
            veh_type_cd: t("pages.vehicleDetails.text02"),
            make: t("pages.vehicleDetails.text06"),
            model: t("pages.vehicleDetails.text07"),
            color: t("pages.vehicleDetails.text08"),
            lic_plate_num: t("pages.vehicleDetails.text04"),
          };

  const deleteVehicleFromBE = () => {
    dispatch(
      deleteVehcile(
        {
          veh_id: selectedVehicle.customerVehicleId,
          lic_plate_num: "",
          make: "",
          model: "",
          color: "",
          status: "I",
          crt_user: "",
          last_upd_user: "",
          cust_id: selectedVehicle.cust_id,
        },
        (data) => {
          if (data?.cust_id) {
            enqueueSnackbar(t("pages.vehicleDetails.text11"), {
              variant: "success",
              autoHideDuration: 3000,
              action: SnackbarConfig,
            });
            navigate(-1);
          } else {
            enqueueSnackbar(data.errorMessage, {
              variant: "error",
              autoHideDuration: 3000,
              action: SnackbarConfig,
            });
          }
        },
      ),
    );
  };

  const myRef = useRef({});

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <NavBar
        title={t("pages.vehicleDetails.pageHeading")}
        redirectTo={"/editVehicle"}
        isReDirect={true}
        enableMenu={false}
      />
      <MenuBar myRef={myRef} />
      <Box
        sx={{
          width: `${lgUp ? "75%" : "100%"}`,
          margin: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Carousel>
          {selectedVehicle?.fileUploadResponse?.map((vehicleMedia, index) => (
            <img
              key={index}
              src={vehicleMedia?.tempUrls}
              style={{
                width: "100%",
                maxHeight: "250px",
                minHeight: "100px",
                objectFit: "contain",
                marginTop: 5,
              }}
              alt=""
            />
          ))}
        </Carousel>
        {Object.keys(vdLayout).map((vd, index) => {
          return (
            <div key={index}>
              {" "}
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "space-between", padding: 2 }}
              >
                <Typography>{vdLayout[vd]}</Typography>
                {vdLayout[vd] === "Vehicle Type" ? (
                  <Typography
                    sx={{
                      fontFamily: "Segoe UI",
                      fontSize: 15,
                      fontWeight: 400,
                      textAlign: "right",
                      color: "#1D5AB9",
                    }}
                  >
                    {getVehicleType(selectedVehicle[vd])}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      fontFamily: "Segoe UI",
                      fontSize: 15,
                      fontWeight: 400,
                      textAlign: "right",
                      color: "#1D5AB9",
                    }}
                  >
                    {selectedVehicle[vd]}
                  </Typography>
                )}
              </Stack>
              <Divider width={"100%"} />
            </div>
          );
        })}
        <Button
          onClick={handleClickOpen}
          variant="contained"
          style={{
            alignSelf: "center",
            width: 199,
            height: 32,
            marginLeft: 88,
            alignItems: "center",
            margin: "auto",
            marginTop: 50,
            display: "flex",
          }}
        >
          <Typography variant="buttonText" color="common.buttonText">
            {t("commonLabels.text03")}
          </Typography>
        </Button>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography
            style={{
              fontFamily: "Segoe UI",
              fontSize: 20,
              fontWeight: 600,
              textAlign: "left",
            }}
          >
            {t("pages.vehicleDetails.text09")} ?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              fontFamily: "Segoe UI",
              fontSize: 18,
              fontWeight: 400,
              textAlign: "left",
            }}
          >
            {t("pages.vehicleDetails.text10")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            style={{
              alignSelf: "center",
              width: 86,
              height: 32,
              marginLeft: 21,
              marginBottom: 3,
              display: "flex",
              backgroundColor: "#fff",
              borderColor: "#8A8886",
              color: "#605E5C",
              borderRadius: 4,
            }}
            onClick={handleClose}
          >
            <Typography
              variant="buttonText"
              color="common.buttonText"
              style={{ color: "#000" }}
            >
              {t("commonLabels.text02")}
            </Typography>
          </Button>
          <Button
            onClick={() => {
              deleteVehicleFromBE();
              setOpen(false);
            }}
            variant="contained"
            style={{
              alignSelf: "center",
              width: 106,
              height: 32,
              right: 10,
              marginLeft: 40,
              marginBottom: 3,
              display: "flex",
              borderRadius: 4,
              border: 1,
            }}
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("commonLabels.text17")}
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VehicleDetails;
